"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritCombienCorporation = void 0;
exports.ESubDejaSouscritCombienCorporation = {
    less_than_3: "less_than_3",
    more_than_3: "more_than_3",
};
